export function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
};

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

// 日期格式化
export const DateUtil = function () {}
// yyyyMMdd...格式化为MM月dd日（星期几）如 20180904--->9月4日 （星期火）
DateUtil.monthDayWeek = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let weeks = ['日', '月', '火', '水', '木', '金', '土']
  let useDate = ''
  if (date.charAt(4) === '0') {
    useDate = useDate + date.charAt(5) + ' 月 '
  } else {
    useDate = useDate + date.substring(4, 6) + ' 月 '
  }
  if (date.charAt(6) === '0') {
    useDate = useDate + date.charAt(7) + ' 日 '
  } else {
    useDate = useDate + date.substring(6, 8) + ' 日 '
  }
  let date1 = date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substr(6, 2)
  let newDate = new Date(date1)
  let week = weeks[newDate.getDay()]
  useDate = useDate + ' ( ' + week + ' )'
  return useDate
}

// yyyyMMddHHmmss格式化为HH:mm   如 20180904090422--->9:04
DateUtil.hourMinute = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let estimateTime = ''
  if (date.charAt(8) === '0') {
    estimateTime = estimateTime + date.charAt(9) + ':'
  } else {
    estimateTime = estimateTime + date.substr(8, 2) + ':'
  }
  // if (date.charAt(10) === '0') {
  //   estimateTime = estimateTime + date.charAt(11)
  // } else {
  //   estimateTime = estimateTime + date.substr(10, 2)
  // }
  estimateTime = estimateTime + date.substr(10, 2)
  return estimateTime
}

// yyyyMMdd...格式化为yyyy年MM月dd日（星期几）如 20180904...--->2018年9月4日（星期火）
DateUtil.yearWeek = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let weeks = ['日', '月', '火', '水', '木', '金', '土']
  let convDate = date.substring(0, 4) + ' 年 '
  if (date.charAt(4) === '0') {
    convDate = convDate + date.charAt(5) + ' 月 '
  } else {
    convDate = convDate + date.substring(4, 6) + ' 月 '
  }
  if (date.charAt(6) === '0') {
    convDate = convDate + date.charAt(7) + ' 日 '
  } else {
    convDate = convDate + date.substr(6, 2) + ' 日 '
  }
  let datetemp = date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substr(6, 2)
  let newDate = new Date(datetemp)
  let week = weeks[newDate.getDay()]
  convDate = convDate + ' ( ' + week + ' )'
  return convDate
}

//  yyyyMMddHHmmss格式化为yyyy年MM月dd日 HH:mm  如 20180904091523--->2018年9月4日 9:15
DateUtil.yearHourMinute = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let tempDate = date.substring(0, 4) + ' 年 '
  if (date.charAt(4) === '0') {
    tempDate = tempDate + date.charAt(5) + ' 月 '
  } else {
    tempDate = tempDate + date.substring(4, 6) + ' 月 '
  }
  if (date.charAt(6) === '0') {
    tempDate = tempDate + date.charAt(7) + ' 日 '
  } else {
    tempDate = tempDate + date.substr(6, 2) + ' 日 '
  }
  if (date.charAt(8) === '0') {
    tempDate = tempDate + date.charAt(9) + ':'
  } else {
    tempDate = tempDate + date.substr(8, 2) + ':'
  }
  // if (date.charAt(10) === '0') {
  //   tempDate = tempDate + date.substr(10, 2)
  // } else {
  //   tempDate = tempDate + date.substr(10, 2)
  // }
  tempDate = tempDate + date.substr(10, 2)
  return tempDate
}
//  yyyyMMddHHmmss格式化为 {date:yyyy 年 MM 月 dd 日 (星期几),time:HH:mm}
DateUtil.yearWeekHourMinute = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let weeks = ['日', '月', '火', '水', '木', '金', '土']
  let pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/
  let newDate = date.replace(pattern, '$1/$2/$3 $4:$5:$6')
  let dateTime = new Date(newDate)
  let tempDate = date.substring(0, 4) + ' 年 '
  if (date.charAt(4) === '0') {
    tempDate = tempDate + date.charAt(5) + ' 月 '
  } else {
    tempDate = tempDate + date.substring(4, 6) + ' 月 '
  }
  if (date.charAt(6) === '0') {
    tempDate = tempDate + date.charAt(7) + ' 日 ' + '(' + weeks[dateTime.getDay()] + ')'
  } else {
    tempDate = tempDate + date.substr(6, 2) + ' 日 ' + '(' + weeks[dateTime.getDay()] + ')'
  }
  let tempTime = date.substr(8, 2) + ':' + date.substr(10, 2)
  return {date: tempDate, time: tempTime}
}
// 日期转化（yyyyMMdd...变换成yyyy年MM月dd日）如 20180904...--->2018年9月4日
DateUtil.yearMonthDay = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let convDate = date.substring(0, 4) + '年'
  if (date.charAt(4) === '0') {
    convDate = convDate + date.charAt(5) + '月'
  } else {
    convDate = convDate + date.substring(4, 6) + '月'
  }
  if (date.charAt(6) === '0') {
    convDate = convDate + date.charAt(7) + '日'
  } else {
    convDate = convDate + date.substr(6, 2) + '日'
  }
  return convDate
}
// yyyyMMddHHmmss转换为Date
DateUtil.str2Date = function (dateStr) {
  if (dateStr === null || dateStr === '') {
    return new Date()
  }
  let pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/
  dateStr = dateStr.replace(pattern, '$1/$2/$3 $4:$5:$6')
  return new Date(dateStr)
}
// yyyyMMdd转换为Date
DateUtil.str2DateyMd = function (dateStr) {
  if (dateStr === null || dateStr === '') {
    return new Date()
  }
  let pattern = /(\d{4})(\d{2})(\d{2})/
  dateStr = dateStr.replace(pattern, '$1/$2/$3')
  return new Date(dateStr)
}

// yyyyMMddHHmmss转换为HH:mm
DateUtil.hourMin = function (dateStr) {
  if (dateStr === null || dateStr === '') {
    let date = new Date()
    return date.getHours() + ':' + date.getMinutes()
  }
  let hourMinStr = ''
  if (dateStr.charAt(8) !== '0') {
    hourMinStr = hourMinStr + dateStr.substr(8, 2)
  } else {
    hourMinStr = hourMinStr + dateStr.substr(9, 1)
  }
  hourMinStr = hourMinStr + ':' + dateStr.substr(10, 2)
  return hourMinStr
}

// 计算年龄（计算给定时间yyyyMMdd到现在为止间隔多少年 如某人几了岁）如 2岁
DateUtil.yearCompute = function (date) {
  if (date === null || date === '') {
    return ''
  }
  // date = date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substring(6)
  if (date) {
    // let year = 1000 * 60 * 60 * 24 * 365
    // let now = new Date()
    // let birthday = new Date(date)
    // let intervalYear = 0
    // if (now >= birthday) {
    //   intervalYear = parseInt((now - birthday) / year)
    // } else {
    //   intervalYear = parseInt((birthday - now) / year)
    // }
    let now = new Date()
    let nowYear = now.getFullYear()
    let nowMonth = now.getMonth() + 1
    let nowDay = now.getDate()
    let intervalYear = nowYear >= Number(date.substring(0, 4)) ? nowYear - Number(date.substring(0, 4)) : 0
    if (nowMonth > Number(date.substring(4, 6))) {
      return intervalYear
    } else {
      if (nowMonth === Number(date.substring(4, 6))) {
        if (nowDay >= Number(date.substring(6))) {
          return intervalYear
        } else {
          return intervalYear - 1
        }
      } else {
        return intervalYear - 1
      }
    }
  }
}

// 计算给定时间到现在为止间隔多少年多少月（计算给定时间yyyyMMdd到现在间隔多少年多少月   如１ヶ月+１日～２ヶ月=２ヶ月）
DateUtil.yearMonthCompute = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let tempDate = new Date(date.substr(0, 4) + '/' + date.substr(4, 2) + '/' + date.substring(6))
  let now = new Date()
  let nowYear = now.getFullYear()
  let nowMonth = now.getMonth() + 1
  let nowDay = now.getDate()
  let dateYear = tempDate.getFullYear()
  let dateMonth = tempDate.getMonth() + 1
  let dateDay = tempDate.getDate()
  let year = 0
  let month = 0
  if (now >= tempDate) {
    month = nowYear * 12 + nowMonth - dateYear * 12 - dateMonth
    if (nowDay > dateDay) {
      month = month + 1
    }
    year = parseInt(month / 12)
    month = month % 12
  } else {
    month = dateYear * 12 + dateMonth - nowYear * 12 - nowMonth
    if (dateDay > nowDay) {
      month = month + 1
    }
    year = parseInt(month / 12)
    month = month % 12
  }
  if (year) {
    if (month) {
      return year + '年' + month + 'ヶ月'
    } else {
      return year + '年'
    }
  } else {
    if (month) {
      return month + 'ヶ月'
    }
  }
  return '1ヶ月'
}

// 将日历组件选择的时间yyyy年MM月dd日转化为日期Date格式
DateUtil.calendarToDate = function (date) {
  if (date === null || date === '') {
    return ''
  }
  // 将yyyy年MM月dd日转化为yyyy-MM-dd
  let formatSelectDate = date.replace('年', '-').replace('月', '-').replace('日', '')
  // 将yyyy-MM-dd转化为日期格式
  return new Date(Date.parse(formatSelectDate))
}

// 将yyyyMMddHHmmss字符转换为Date
DateUtil.stringToDate = function (date) {
  let pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/
  let formatedDate = date.replace(pattern, '$1/$2/$3 $4:$5:$6')
  return new Date(formatedDate)
}

// 将yyyymmdd字符串转化为Date
DateUtil.shortStringToDate = function (date) {
  let pattern = /(\d{4})(\d{2})(\d{2})/
  let formatedDate = date.replace(pattern, '$1/$2/$3')
  return new Date(formatedDate)
}

// 计算两个日期之间有几个周几
DateUtil.getWeekCount = function (startDate, endDate, week) {
  let count = 0
  while (true) {
    if (startDate <= endDate) {
      if (startDate.getDay() === week) {
        count++
      }
      // startDate = new Date(startDate.setDate(startDate.getDate() + 1))
      startDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000)
    } else {
      break
    }
  }
  return count
}

// 统计两个日期之间是周几的日期集合
DateUtil.getWeekDateList = function (startDate, endDate, week) {
  let dateList = []
  while (true) {
    if (startDate <= endDate) {
      if (startDate.getDay() === week) {
        dateList.push(startDate)
      }
      // startDate = new Date(startDate.setDate(startDate.getDate() + 1))
      startDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000)
    } else {
      break
    }
  }
  return dateList
}

// 将date格式转化为yyyy年MM月dd日
DateUtil.dateToString = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  return year + '年' + month + '月' + day + '日'
}

// 获取yymmdd日期格式的年
DateUtil.getYear = function (date) {
  if (date !== null && date !== '') {
    let year = date.substr(0, 4)
    return parseInt(year)
  }
}

// 获取yymmdd日期格式的月
DateUtil.getMonth = function (date) {
  if (date !== null && date !== '') {
    if (date.charAt(4) === '0') {
      return parseInt(date.charAt(5))
    } else {
      return parseInt(date.substr(4, 2))
    }
  }
}

// 获取yymmdd日期格式的日
DateUtil.getDay = function (date) {
  if (date !== null && date !== '') {
    if (date.charAt(6) === '0') {
      return parseInt(date.charAt(7))
    } else {
      return parseInt(date.substr(6, 2))
    }
  }
}

// 将yyyyMMdd转化为MM月dd日(星期几)
DateUtil.yMd2MdW = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let weeks = ['日', '月', '火', '水', '木', '金', '土']
  let dateStr = date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substring(6, 8)
  let newDate = new Date(dateStr)
  return (newDate.getMonth() + 1) + '月' + newDate.getDate() + '日' + '(' + weeks[newDate.getDay()] + ')'
}
// 将yyyyMMdd转化为MM 月 dd 日 (星期几)
DateUtil.yMd2M_d_W = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let weeks = ['日', '月', '火', '水', '木', '金', '土']
  let dateStr = date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substring(6, 8)
  let newDate = new Date(dateStr)
  return (newDate.getMonth() + 1) + ' 月 ' + newDate.getDate() + ' 日 ' + '(' + weeks[newDate.getDay()] + ')'
}
// 将yyyyMMdd转化为yyyy年MM月dd日(星期几)
DateUtil.yyyyMMdd = function (date) {
  // 20180906
  if (!date) {
    return ''
  }
  let weeks = ['日', '月', '火', '水', '木', '金', '土']
  let dateStr = date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substring(6, 8)
  let newDate = new Date(dateStr)
  return newDate.getFullYear() + '年' + (newDate.getMonth() + 1) + '月' + newDate.getDate() + '日' + '  (' + weeks[newDate.getDay()] + ')'
}

// 将yyyyMMdd转化为yyyy年MM月dd日
DateUtil.yyyyMMdd = function (date) {
  // 20180906
  if (!date) {
    return ''
  }
  let dateStr = date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substring(6, 8)
  let newDate = new Date(dateStr)
  return newDate.getFullYear() + '年' + (newDate.getMonth() + 1) + '月' + newDate.getDate() + '日'
}

// 将yyyyMMddHHmm转化为 yyyy/mm/dd HH:mm 用在MessageInfoList中
DateUtil.yearMonthDayandTime = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let convDate = date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substring(6, 8) + ' ' +
  date.substring(8, 10) + ':' + date.substring(10, 12)
  return convDate
}

// 将yyyyMMdd转化为 yyyy/mm/dd 用在DriverList有效允许期限当中
DateUtil.yearMonthandDay = function (date) {
  if (date === null || date === '') {
    return ''
  }
  let convDate = date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substring(6, 8)
  return convDate
}
DateUtil.planDateAdd = function (date, pickUpWaitTime) {
  let year = date.substring(0, 8)
  let hour = Number(date.substring(8, 10))
  let min = Number(date.substring(10, 12))
  let ss = Number(date.substring(12, 14))
  if (min + pickUpWaitTime / 60 > 60) {
    hour++
    min = (min + (ss + pickUpWaitTime) / 60) % 60
  } else if (min + pickUpWaitTime / 60 > 0) {
    min = min + pickUpWaitTime / 60
  } else {
    hour--
    min = min + 60
    min = ((min * 60 + ss) + pickUpWaitTime) / 60
  }
  if (hour < 10) {
    hour = '0' + hour
  }
  if (min < 10) {
    min = '0' + min
  }
  return year + hour + min + ss
}
// 计算乘车预定时间（yyyyMMddHHmmss-mm）
DateUtil.planMin = function (date, time, flag, pickUpWaitTime) {
  time = parseInt(time / 60)
  pickUpWaitTime = pickUpWaitTime / 60
  if (date === null || date === '') {
    return ''
  }
  let estimateTime = ''
  if (date.charAt(8) === '0') {
    estimateTime = estimateTime + date.charAt(9) + ':'
  } else {
    estimateTime = estimateTime + date.substr(8, 2) + ':'
  }
  estimateTime = estimateTime + date.substr(10, 2)
  let year = date.substr(0, 8)
  date = estimateTime
  let min = ''
  let hour = ''
  let pickTime
  min = parseInt(date.substring(date.indexOf(':') + 1))
  hour = parseInt(date.substring(0, date.indexOf(':')))
  // if (min - pickUpWaitTime > 0) {
  //   min = min - pickUpWaitTime
  // } else {
  //   hour--
  //   min = (min + 60) - pickUpWaitTime
  // }
  if (pickUpWaitTime + min >= 60) {
    min = (pickUpWaitTime + min) % 60
    hour++
  } else {
    min = pickUpWaitTime + min
  }
  if (hour < 10) {
    pickTime = year + '0' + hour
  } else {
    pickTime = year + hour
  }
  if (min < 10) {
    pickTime = pickTime + '0' + min
  } else {
    pickTime = pickTime + min
  }
  pickTime = pickTime + '00'
  min = min + hour * 60
  // 行き
  if (flag === 0) {
    min = min - time
  } else {
    min = min + time
  }
  hour = parseInt(min / 60)
  min = parseInt(min % 60)
  if (hour < 10) {
    year = year + '0' + hour
  } else {
    year = year + '' + hour
  }
  if (min < 10) {
    min = '0' + min
    year = year + min
  } else {
    year = year + '' + min
  }
  let convDate = [year, hour + ':' + min, pickTime]
  return convDate
}
// time 推算的时间  flag 行归
DateUtil.planTimeList = function (legs, time, flag) {
  if (!Object.is(time, '')) {
    time = time.split(':')
    time[0] = parseInt(time[0]) * 60
    time[1] = parseInt(time[1])
  }
  let planTime = []
  let sum = time[0] + time[1]
  for (let index = 0; index < legs.length; index++) {
    const item = legs[index]
    let mins = parseInt(item.durationVaue)
    // 行き
    if (flag === '0') {
      sum = sum - mins
    } else {
      sum = sum + mins
    }
    planTime.push({hour: parseInt(sum / 60), min: parseInt(sum % 60)})
  }
  return planTime
}
// 将YYYY年MM月dd日格式化为：YYYYMMdd 如2018 年 9 月 20 日  ( 木 )--->20180920
DateUtil.getYearMonthDay = function (date) {
  if (date !== null && date !== '') {
    let moveShiftTimeYear = date.substr(0, 4)
    date = date.replace(' 年 ', '年').replace(' 月 ', '月').replace(' 日 ', '日')
    let yearIndex = date.indexOf('年')
    let monthIndex = date.indexOf('月')
    let dayIndex = date.indexOf('日')
    let month = date.substring(yearIndex + 1, monthIndex)
    let day = date.substring(monthIndex + 1, dayIndex)
    let moveShiftTimeMonth = month < 10 ? '0' + month : month
    let moveShiftTimeDay = day < 10 ? '0' + day : day
    return moveShiftTimeYear + moveShiftTimeMonth + moveShiftTimeDay
  }
}



// WEBPACK FOOTER //
// ./src/utils/date.js